import React from "react";
import PropTypes from "prop-types";
import styles from "./LabelText.module.scss";

const LabelText = ({
	children,
	className,
	style,
	onClickHandler,
	uniqueLabelId,
}) => {
	return (
		<label
			className={`${className} ${styles["label-text"]}`}
			style={style}
			onClick={onClickHandler}
			id={uniqueLabelId}
		>
			{children}
		</label>
	);
};

LabelText.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	style: PropTypes.object,
};

export default LabelText;
